










































import { Component, Vue, Watch } from 'vue-property-decorator';
import List from '@/components/list.vue';
import { searchAll } from '@/api/task/common';
import { goTop } from '../../global/utils';

@Component({
  components: {
    List,
  },
})
export default class Task extends Vue {
  private dataList: object = {};
  private loading: boolean = false;
  private searched: boolean = false;
  private total: number = 0;
  private params: object = {
    q: '',
  };
  
  private created() {
    let q = this.$route.query.q;
    let category_id = this.$route.query.category_id;
    let type = this.$route.query.type;
    let searchExpTask = {};
    if(q){
      (this.params as any).q = q;
      searchExpTask={q:q}
      this.getList(searchExpTask);
    }else if(category_id){
      let expName = this.$route.query.expName;
      (this.params as any).q = expName;
      searchExpTask={exp_category_id:category_id,"type":2}
      this.getList(searchExpTask);
    }
    this.searched = true;
    
  }
  private handleSearch() {
    this.getList(this.params);
    this.searched = true;
  }
  // 重置
  private clearSearch() {
    (this.params as any).q = null;
    this.getList(this.params);
  }
  // 获取列表数据
  private async getList(params) {
    goTop();
    this.loading = true;
    try {
      const data: any = await searchAll(params);
      let count = 0;
      for (let key in data) {
        count += data[key].length;
      }
      this.$nextTick(() => {
        this.dataList = data ? data : {};
        this.total = count;
      });
    } catch (err) {
      console.log(err);
    }
    this.loading = false;
  }
}
